// extracted by mini-css-extract-plugin
export default {"blade":"FullWidthBlade_blade__XQir8"};